// extracted by mini-css-extract-plugin
export var banner = "_3r-0";
export var icon = "_3r-1";
export var message = "_3r-2";